import questionIcon from '@raison/static/icons/question-line.svg';
import {InlineSvg} from '@raison/ui-kit';
import React, {PropsWithChildren} from 'react';

export function LabelWithInfo({onClick, children}: PropsWithChildren<{onClick: () => void}>) {
    return (
        <div className={'flex items-center gap-1'}>
            {children}
            <button type={'button'} className={'cursor-pointer leading-[0] text-neutral-60'}>
                <InlineSvg src={questionIcon} onClick={onClick} className={'size-3'} />
            </button>
        </div>
    );
}
